module.exports = __webpack_public_path__ + "img/pagenotfound.a56bd93c.svg";